import React, { useState, useEffect, Fragment, forwardRef } from 'react';
import { Row, Label, Col, Button, Input, Form, FormGroup, Card } from "reactstrap";
import { toast } from "react-toastify";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import Dropzone from 'react-dropzone-uploader';
import RequiredIndicator from '../../../../partial/RequiredIndicator';
import { mykyc, setDealerPanNSDLVerify } from '../../../../../redux/kyc/action';
import { updateDealer, validatePanCard } from '../../../../../api';
import handleupload from '../../../../../utilities/handleUpload';
import validateFile from '../../../../../utilities/validateFile';
import PDFViewer from '../../../../../utilities/PDFViewer';
import { Edit, Info, InfoOutlined } from "@mui/icons-material";
import FileUploadComponent from '../../../../common/FileUpload';
import { KYC_NOTE_1, KYC_NOTE_2, KYC_NOTE_EDIT_1, KYC_NOTE_EDIT_2, verifyButton } from '../../../../../constant';
import KycEditNote from '../../kyc_note/KycEditNote';
import KycViewNote from '../../kyc_note/KycViewNote';
import { getFromLocalStorage, setInLocalStorage } from '../../../../../hooks/useLocalStorage';
import kycSpecialCharacterConstrains from '../../../../../utilities/kycSpecialCharacterConstrains';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const Pan = (props) => {
    const { activeStep, setActiveStep, setStep1Valid, dealerKycData, is_kyc_submitted, is_kyc_active, setIsUpdated, dealershipData } = props;
    const [gstnStateCode] = useState(27);
    const [loading, setLoading] = useState(false);

    const [panUrl, setPanUrl] = useState("");
    const { handleSubmit, register, setValue, getValues, errors, setError, trigger } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [ispanVerify, setIsPanVerify] = useState(false);
    const [isPanVerification, setIsPanVerification] = useState(false);
    const [panVerifiedDealerName, setPanVerifiedDealerName] = useState("");
    const [verifyLoading, setVerifyLoading] = useState(false);


    // Redux data
    const kycData = useSelector((content) => content.Kyc);
    const dispatch = useDispatch();

    const submitForm = async (data) => {
        console.log(data, "om submit");
        const storedData = await kycData.panCard;
        if (storedData.panNSDLVerify) {
            setLoading(true);
            setIsSubmitting(true);

            dispatch(mykyc({ ...kycData, panCard: { ...kycData.panCard, ...data }, txnid: Date.now() }))
            if (activeStep === 0) {
                setIsSubmitting(false);
                setStep1Valid(true);
                setActiveStep((prevActiveStep) => prevActiveStep + 1);

            } else {
                setIsSubmitting(false);
                setStep1Valid(true);
                // setStep2Valid(true);
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }

            setIsUpdated(true)
            setTimeout(() => {
                setIsUpdated(false)
            }, 2000);
        } else {
            toast.error("PAN details not verified");
            return
        }

    };

    //Uncomment this for Tax API
    // const submitForm = async (data) => {
    //     console.log(data, "om submit");
    //     const storedData = await kycData.panCard;
    //     if (storedData.panNSDLVerify) {
    //         setLoading(true);
    //         setIsSubmitting(true);

    //         // if (data.dealer_pan_card_number !== storedData.dealer_pan_card_number) {
    //         //     try {
    //         //         const panNSDLPayload = { panNumber: data.dealer_pan_card_number }

    //         //         const panNSDLVerifiedRes = await validatePanCard(panNSDLPayload);
    //         //         if (panNSDLVerifiedRes?.status == 200) {                  
    //         //             dispatch(setDealerPanNSDLVerify(true));
    //         //             await dispatch(mykyc({ ...kycData, panCard: { ...kycData.panCard, ...data }, txnid: Date.now() }))
    //         //             if (activeStep === 0) {
    //         //                 setIsSubmitting(false);
    //         //                 setStep1Valid(true);
    //         //                 setActiveStep((prevActiveStep) => prevActiveStep + 1);

    //         //             }
    //         //         }else{
    //         //             return false
    //         //         }
    //         //     } catch (error) {
    //         //         toast.error(error?.response?.data?.error ? error?.response?.data?.error : 'NSDL:Invalid PAN Card details');
    //         //         setIsSubmitting(false);
    //         //         return;
    //         //     }
    //         // }else{
    //         dispatch(mykyc({ ...kycData, panCard: { ...kycData.panCard, ...data }, txnid: Date.now() }))
    //         if (activeStep === 0) {
    //             setIsSubmitting(false);
    //             setStep1Valid(true);
    //             setActiveStep((prevActiveStep) => prevActiveStep + 1);

    //         }
    //         // }
    //         // console.log(data, "data", { ...kycData.panCard, ...data }, "{...kycData.panCard, ...data}", kycData.panCard, "...kycData.panCard")
    //         setIsUpdated(true)
    //         setTimeout(() => {
    //             setIsUpdated(false)
    //         }, 2000);
    //     } else {
    //         toast.error("PAN details not verified");
    //         return
    //     }

    // };

    const verifyPanDetails = async (data) => {
        // console.log(data, "pan data111111")
        setIsPanVerification(false);
        const dealer_name = dealershipData?.dealer_name;
        const dealership_id = dealershipData?.dealership_id;
        const dealer_pan_card_number = data;
        if (!dealer_pan_card_number) {
            toast.error("Please enter PAN card number");
            return
        }
        // setPanLoading(true);
        setVerifyLoading(true);
        setIsPanVerify(true);
        // const storedData = await kycData.panCard;
        // if (dealer_pan_card_number !== storedData.dealer_pan_card_number) {
        try {
            const panNSDLPayload = { panNumber: dealer_pan_card_number }

            const panNSDLVerifiedRes = await validatePanCard(panNSDLPayload);
            console.log(panNSDLVerifiedRes, "panNSDLVerifiedRes");


            if (panNSDLVerifiedRes?.status == 200) {
                const pan_verified_dealer_name = panNSDLVerifiedRes?.data?.result?.msg?.name;
               
                const DealerData = {
                    dealer_name: pan_verified_dealer_name
                };
                if (dealer_name.trim().toLowerCase() == pan_verified_dealer_name.trim().toLowerCase()) {
                    setPanVerifiedDealerName(dealer_name);
                    dispatch(setDealerPanNSDLVerify(true));
                    // toast.success("Details are verified");
                    Swal.fire({
                            icon: 'info',
                            // title: '',
                            html: `Please verify that the name (<b>${dealer_name}</b>) captured matches the PAN document. Kindly note that further name changes will not be permitted after KYC submission`,
                            showCancelButton: false,
                            confirmButtonText: 'Confirm',
                        })
                    setVerifyLoading(false);
                } else {
                    Swal.fire({
                        icon: 'info',
                        // title: '',
                        html: `Please verify that the name <b>${pan_verified_dealer_name}</b> captured matches the PAN document. Kindly note that further name changes will not be permitted after KYC submission`,
                        showCancelButton: true,
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                    }).then(async (result) => {
                        if (result.isConfirmed) {

                            // await updateDealer(dealership_id, DealerData)
                            //     .then((res) => {
                                    // setPanVerifiedDealerName(pan_verified_dealer_name);
                                    setPanVerifiedDealerName(pan_verified_dealer_name);
                                    dispatch(setDealerPanNSDLVerify(true));
                                    toast.success("Dealer name updated successfully as per PAN details");

                                    // Handle success response
                                // }).catch((err) => {
                                    // toast.error("Something went wrong");
                                    // setIsPanVerify(false);

                                // });
                            setVerifyLoading(false);

                        }else{
                            setIsPanVerify(false);
                            setVerifyLoading(false);
                        }
                    });

                    // const userData = getFromLocalStorage("user");
                    // if (userData && userData.dealerInfo) {
                    //     userData.dealerInfo.dealer_name = pan_verified_dealer_name;
                    //     setInLocalStorage("user", userData)
                    // }
                    setIsPanVerification(true);
                }
                // await dispatch(mykyc({ ...kycData, panCard: { ...kycData.panCard, ...data }, txnid: Date.now() }))

            } else {
                return false
            }
        } catch (error) {
            toast.error(error?.response?.data?.error ? error?.response?.data?.error : 'Something went wrong');
            setIsPanVerify(false);
            setVerifyLoading(false);
            return;
        }
        // }else{
        // dispatch(mykyc({ ...kycData, panCard: { ...kycData.panCard, ...data }, txnid: Date.now() }))
        // }
        // console.log(data, "data", { ...kycData.panCard, ...data }, "{...kycData.panCard, ...data}", kycData.panCard, "...kycData.panCard")
        setIsUpdated(true)
        setTimeout(() => {
            setIsUpdated(false)
        }, 2000);

    };

    const onSubmitForKycSubmitComplete = () => {
        if (activeStep === 0) {
            setStep1Valid(true);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);

            Swal.fire({
                icon: 'info',
                html: `Name of the Dealership will be updated everywhere as per your conformation`,
                showCancelButton: false,
                confirmButtonText: 'OK',
            })

        }
    }

    const onSubmitForKycSubmitCompleteNew = () => {
        if (activeStep === 0) {
            Swal.fire({
                icon: 'info',
                html: `Name of the Dealership will be updated everywhere as per your conformation`,
                showCancelButton: false,
                confirmButtonText: 'OK',
            })

        }
    }

    useEffect(() => {
        const storedData = kycData?.panCard;
        Object.keys(storedData).forEach((fieldName) => {
            setValue(fieldName, storedData[fieldName]);
        });
        setPanUrl(getValues()["user_pan_card_image"])

    // }, [kycData.panCard.dealer_pan_card_name]);

    }, [kycData.panCard.user_pan_card_name]);

    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    // useEffect(() => {
    //     if (panVerifiedDealerName) {
    //       updateDealerName(panVerifiedDealerName); 
    //     }
    //   }, [panVerifiedDealerName]);

    return (
        <Fragment>
            <Row>
                <Col xl="12" md="12" sm="12" className="mt-4" key={1}>
                    <div className="project-box">
                        {is_kyc_active ? (<span className={`badge badge-success`}>{"Verified"}</span>) : ''}

                        <div className='mt-3'>
                            {(is_kyc_submitted || is_kyc_active) ? (
                                <>
                                    <Row>
                                        <Col xl="6" md="6">
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label className='col-form-label fw-10'>{"PAN Card Number"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="dealer_pan_card_number"
                                                            type="text"
                                                            defaultValue={kycData?.panCard?.dealer_pan_card_number}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Name on the Card"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="dealer_pan_card_name"
                                                            type="text"
                                                            defaultValue={kycData?.panCard?.dealer_pan_card_name}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <KycViewNote />
                                        </Col>

                                        <Col xl="6" md="6" className="d-flex justify-content-center">
                                            {/* Second Column Content */}
                                            <FormGroup className='text-center'>
                                                <Label>{"Pan document"}</Label>

                                                <FileUploadComponent name="dealer_pan_card_image" fileUploadFlag={false} data={kycData?.panCard?.dealer_pan_card_image} viewOnly={true} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-end">
                                        <Button color="info" type="submit" onClick={onSubmitForKycSubmitComplete}>
                                            {loading ? "Loading..." : "Next"}
                                        </Button>
                                    </Row>
                                </>
                            ) : getFromLocalStorage("ROLE")?.key == "DEALERSHIP_MANAGER" && (
                                <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(submitForm)} >
                                    <Row>
                                        <Col xl="6" md="6">
                                            <Row>
                                                {/* <Col xl="12" md="12"> */}
                                                <Col xl="9" md="9">
                                                    <FormGroup>
                                                        <Label className='col-form-label fw-10'>{"PAN Card Number"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="dealer_pan_card_number"
                                                            type="text"
                                                            defaultValue={getValues()["dealer_pan_card_number"]}
                                                            // readOnly={!is_kyc_submitted}
                                                            innerRef={register({
                                                                required: 'Pan Number is required',
                                                                pattern: {
                                                                    value: panPattern,
                                                                    message: "Invalid Pan Number"
                                                                }
                                                            })}
                                                            onChange={(e) => {
                                                                setIsPanVerification(false);
                                                                const upperCasePan = e.target.value.toUpperCase();

                                                                e.target.value = upperCasePan;

                                                                dispatch(mykyc({ ...kycData, gstn: { ...kycData.gstn, gstn_number: gstnStateCode + upperCasePan }, txnid: Date.now() }))
                                                            }}
                                                            readOnly={kycData?.panCard?.panNSDLVerify ? true : false}
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {errors.dealer_pan_card_number && errors?.dealer_pan_card_number?.message}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                                <Col xl="3" md="3" className="verify-button">

                                                    {kycData?.panCard?.panNSDLVerify ?
                                                        <Button color="success" className="verify-pan-button" disabled>
                                                            <FontAwesomeIcon icon={faCheck} />
                                                        </Button>
                                                        :
                                                        <Button color="info"
                                                            className="verify-pan-button"
                                                            onClick={() => verifyPanDetails(getValues()["dealer_pan_card_number"])}
                                                            disabled={ispanVerify}> {verifyLoading ? 'Loading...' : verifyButton} </Button>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Name on the Card"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="dealer_pan_card_name"
                                                            type="text"
                                                            innerRef={register(kycSpecialCharacterConstrains(true, "Name on the Card is required"))}
                                                            // defaultValue={getValues()["dealer_pan_card_name"]}
                                                            value={panVerifiedDealerName ? panVerifiedDealerName : getValues()["dealer_pan_card_name"]}
                                                            readOnly
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {/* {errors.dealer_pan_card_name && "Name on the Card is required"} */}
                                                            {errors?.dealer_pan_card_name?.message}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <KycEditNote />
                                        </Col>

                                        <Col xl="6" md="6" className="d-flex justify-content-center">
                                            <FormGroup className='text-center'>
                                                <Label>{"Upload PAN document"}</Label> <RequiredIndicator />
                                                <FileUploadComponent
                                                    register={register}
                                                    name="dealer_pan_card_image"
                                                    setValue={setValue}
                                                    trigger={trigger}
                                                    getValues={getValues}
                                                    data={panUrl}
                                                    add={getValues()["dealer_pan_card_image"]?.length > 0 ? false : true}
                                                    pdfImageOnly={true}
                                                />
                                                <span style={{ color: "red" }}>
                                                    {errors.dealer_pan_card_image && "PAN document is required"}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-end">
                                        <Button color="info" type="submit" disabled={isSubmitting} onClick={onSubmitForKycSubmitCompleteNew}>
                                            {isSubmitting ? 'Loading...' : 'Save'} <span>&gt;&gt;</span>
                                        </Button>
                                    </Row>
                                </Form>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
};

export default Pan;